/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { Tab } from '../model/tab.model';
import { TabData } from '../model/tab-data.model';
import { UtilService } from './util.service';

/**
 * @export
 * @class DataStoreService
 */
@Injectable()
export class DataStoreService {
    private datastore = new Array<TabData>();

    constructor(private utilService: UtilService) {
    }

    /**
     * This is used to get already saved Data from Store
     * @returns {Array<TabData>}
     * @memberOf DataStoreService
     */
    getDataStore(): Array<TabData> {
        return this.utilService.deepClone(this.datastore);
    }

    /**
     * This is used to get value from Store using key
     * @param {Tab} key
     * @returns {TabData}
     * @memberOf DataStoreService
     */
    getValue(key: Tab): TabData {
        const data = this.datastore.find((ds) => { return (ds && ds.id === key.id && !(_.isEmpty(ds.data[key.subType]))); });
        if (key.subType.toLowerCase() === 'history' || key.type.toLowerCase() === 'outlying-points' || key.type.toLowerCase() === 'query-view') {
            return data;
        }
        if (data) {
            return this.utilService.deepClone(data);
        } else {
            return null;
        }
    }

    /**
     * This is used to put value into datastore using key
     * @param {Tab} key
     * @param {TabData} value
     * @memberOf DataStoreService
     */
    putValue(tab: Tab, value: TabData) {
        if (this.isTabExist(tab)) {
            let indexPosition = _.findIndex(this.datastore, function (o) { return o && o.id === value.id; });
            if (indexPosition < 0) {
                indexPosition = this.datastore.length;
            } else {
                if (this.datastore[indexPosition] && this.datastore[indexPosition].data && this.datastore[indexPosition].data[tab.subType]) {
                    delete this.datastore[indexPosition].data[tab.subType];
                }
            }
            if (tab.subType.toLowerCase() === 'history' || tab.type.toLowerCase() === 'outlying-points' || tab.type.toLowerCase() === 'query-view') {
                this.datastore[indexPosition] = _.merge(this.datastore[indexPosition], value);
            } else {
                this.datastore[indexPosition] = _.merge(this.datastore[indexPosition], this.utilService.deepClone(value));
            }

        } else {
            if (tab.subType.toLowerCase() === 'history' || tab.type.toLowerCase() === 'outlying-points' || tab.type.toLowerCase() === 'query-view') {
                this.datastore.push(value);
            } else {
                this.datastore.push(this.utilService.deepClone(value));
            }
        }

    }

    /**
     * @private
     * @param {Tab} key
     * @returns
     *
     * @memberOf DataStoreService
     */
    private isTabExist(key: Tab) {
        return this.datastore.filter((ds) => { return ds && ds.id === key.id; }).length;

    }
    /**
     * This is used to remove tab from Data Store
     * @param {Tab} key
     * @memberOf DataStoreService
     */
    removeTab(key: Tab) {
        this.datastore = this.datastore.filter((ds) => { return ds && ds.id !== key.id; });
    }

    /**
     * This is used to remove sub Tabs
     * @param {Tab} key
     * @memberOf DataStoreService
     */
    removeSubPanel(key: Tab) {
        const foundData = this.datastore.find((data) => { return data && key.id === data.id; });
        if (foundData && foundData.data && foundData.data[key.subType]) {
            delete foundData.data[key.subType];
        }
    }

}
